import Prefectures from "components/PrefecturesOption";

export function formatMobileNumberJapaneseToCountryCode(phoneNumber: string): string {
  // 電話番号からハイフンやスペースなどの区切り文字を除去
  const cleanedNumber = phoneNumber.replace(/[\s\-]/g, '');
  // 電話番号の長さが10桁以上の場合は国番号を付ける
  if (cleanedNumber.length >= 10) {
    return `+81${cleanedNumber}`;
  }
  // 電話番号の長さが10桁未満の場合はそのまま返す
  return cleanedNumber;
};

export function formatMobileNumberCountryCodeToJapanese(phoneNumber: string): string {
  if (!phoneNumber) {
    return '';
  }
  let removed: string = phoneNumber.slice(3);
  return removed;
}

export function getPrefectureNameByCode(code: number): string | undefined {
  const prefecture = Prefectures.find((p) => p.code === code);
  return prefecture ? prefecture.name : undefined;
}

export function formatNumberToDigits(number: number, digits: number): string {
  const numberString = number.toString();
  const paddedNumber = numberString.padStart(digits, '0');
  return paddedNumber;
}